import Moment from 'moment'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ETable from '../../../elements/components/table'

const propTypes = {
    items: PropTypes.array,
    page: PropTypes.number,
    perPage: PropTypes.number,
}
const defaultProps = {
    items: [],
    page: 1,
    perPage: 25
}

class AuditTable extends Component {


    render() {

        const columns = [
            {
                dataField: 'KDY_UPD',
                text: 'Datum',
                classes: 'text-nowrap align-middle',
                sort: true,
                formatter: (cell, row, index) => (
                    <span>{Moment(cell).format('DD.MM.YYYY HH:mm')}</span>
                )
            },
            {
                dataField: 'LAKOVNA_TYP_MATERIALU_POPIS',
                text: 'Materiál',
                headerClasses: 'max-width',
                classes: 'text-nowrap align-middle'
            },
            {
                dataField: 'LAKOVNA_AKCE_POPIS',
                text: 'Akce',
                headerClasses: 'max-width',
                classes: 'text-nowrap align-middle'
            },
            {
                dataField: 'AKCE',
                text: '#',
                classes: 'text-nowrap align-middle'
            },
            {
                dataField: 'UZIV_INTRA_POPIS',
                text: 'Uživatel',
                sort: true,
                classes: 'text-nowrap align-middle'
            }
        ]


        return (
            <ETable
                className="table-lg"
                keyField='KDY_UPD'
                data={this.props.items}
                columns={columns}
                pagination={{
                    page: this.props.page,
                    sizePerPage: this.props.perPage,
                    onPageChange: this.props.onPageChange
                }} />
        )
    }
}

AuditTable.propTypes = propTypes
AuditTable.defaultProps = defaultProps

export default AuditTable
